import { AccountTriageState } from '@interfaces/state';
import { createAction, props } from '@ngrx/store';

export const ClearAccountTriageState = createAction(
  '[Clear Account Triage State] Account Triage: Clear State',
);

export const AccountTriageContinue = createAction('[Account Triage] Account Triage: Continue');

export const SetFirstNewAccountTransaction = createAction(
  '[Account Triage] Set First New Account Transaction',
);

export const CheckFirstNewAccountTransaction = createAction(
  '[Account Triage] Check First New Account Transaction',
);

export const ClearNewAccountData = createAction('[Account Triage] Clear New Account Data');

export const UpdateAccountTriageSelections = createAction(
  '[Update Account Triage Selection] Account Triage: Update Selection',
  props<{ payload: Partial<AccountTriageState> }>(),
);
